'use client'

import { Route, Routes } from 'react-router-dom'

import { KybForm } from '@marketplace-web/domain/pay-identity-kyc'

import { AuthenticatedRoute, CompatibleRouter } from '@marketplace-web/shared/ui-helpers'
import { BUSINESS_ACCOUNTS_HOMEPAGE } from 'constants/routes'
import { serverSide } from '@marketplace-web/shared/environment'

import { useLocation } from '@marketplace-web/shared/browser'

import ProNavBar from '../../components/ProNavBar'
import Register from '../../components/Register'
import { ROUTES } from '../../constants/routes'
import WalletConversion from './WalletConversion'
import AddVatPage from './AddVatPage/AddVatPage'

const BusinessAccounts = () => {
  const { relativeUrl } = useLocation()

  return (
    <CompatibleRouter basename={ROUTES.BASE} location={relativeUrl} isServerSide={serverSide}>
      <div className="u-flexbox u-flex-direction-column u-fill-viewport">
        <ProNavBar />
        <div className="u-flex-grow">
          <Routes>
            <Route
              path={`${ROUTES.REGISTER.BASE}/*`}
              element={
                <AuthenticatedRoute redirectRailsRoute={BUSINESS_ACCOUNTS_HOMEPAGE}>
                  <Register />
                </AuthenticatedRoute>
              }
            />
            <Route
              path={ROUTES.WALLET_CONVERSION}
              element={
                <AuthenticatedRoute redirectRailsRoute={BUSINESS_ACCOUNTS_HOMEPAGE}>
                  <WalletConversion />
                </AuthenticatedRoute>
              }
            />
            <Route
              path={ROUTES.KYB_FORM}
              element={
                <AuthenticatedRoute redirectRailsRoute={BUSINESS_ACCOUNTS_HOMEPAGE}>
                  <KybForm />
                </AuthenticatedRoute>
              }
            />
            <Route
              path={ROUTES.ADD_VAT}
              element={
                <AuthenticatedRoute redirectRailsRoute={BUSINESS_ACCOUNTS_HOMEPAGE}>
                  <AddVatPage />
                </AuthenticatedRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </CompatibleRouter>
  )
}

export default BusinessAccounts
